export default __webpack_public_path__ + "static/media/auroraestoreaxios-min.54b825e9.png";